@use '../../scss/utility';

@use './button-common';
@use './button-style-api';

:host {
  @include button-common.wb-button;

  .button {
    @include button-common.wb-button-inner;
    @include button-common.wb-button-normalizing;
    @include utility.wb-text(
      'l',
      (
        strong: true,
        responsive: false,
      )
    );
  }

  .wb-spinner {
    @include button-common.wb-button-spinner;
  }
}

::slotted(.wb-icon) {
  @include button-common.wb-button-icon;
}

::slotted(.wb-icon[name*='/']) {
  --size: #{utility.wb-pixel-to-rem(16px)};
}

:host([disabled]) {
  @include button-common.wb-button-disabled; // for the anchor

  .button {
    cursor: not-allowed; // for the button
  }

  slot,
  .wb-spinner {
    pointer-events: none; // prevent slotted elements and wb-spinner from emitting click events
  }
}

:host([size='l']) {
  --spinner-size: #{utility.wb-pixel-to-rem(32px)};

  .button {
    @include button-common.wb-button-size-l;
  }
}

:host([size='m']) {
  --spinner-size: #{utility.wb-pixel-to-rem(24px)};

  .button {
    @include button-common.wb-button-size-m;
  }
}

:host([size='s']) {
  --spinner-size: #{utility.wb-pixel-to-rem(16px)};

  .button {
    @include button-common.wb-button-size-s;
  }
}

:host([variant='tertiary'][size='l']) .button {
  @include button-common.wb-button-tertiary-size-l;
}

:host([variant='tertiary'][size='m']) .button {
  @include button-common.wb-button-tertiary-size-m;
}

:host([variant='tertiary'][size='s']) .button {
  @include button-common.wb-button-tertiary-size-s;
}

:host([loading]) {
  .button {
    color: transparent !important;
  }

  .wb-spinner {
    opacity: 1;
  }
}

:host([variant='tertiary']),
:host([icon-only]) {
  min-width: initial;
}

:host([icon-only]) .button {
  @include button-common.wb-button-icon-only;
}

:host([icon-only]) ::slotted(.wb-icon) {
  --size: #{utility.wb-pixel-to-rem(16px)};
}

:host([icon-only]) ::slotted(.wb-icon[name*='/']) {
  --size: #{utility.wb-pixel-to-rem(24px)};
}

:host([icon-only][size='l']) .button {
  @include button-common.wb-button-icon-only-size-l;
}

:host([icon-only][size='m']) .button {
  @include button-common.wb-button-icon-only-size-m;
}

:host([icon-only][size='s']) .button {
  @include button-common.wb-button-icon-only-size-s;
}
